'use strict';

require('./parsers/index.js');

//# sourceMappingURL=index.js.map
